import { trackSignUpButtonClicked } from '@cointracker/landing-app/src/common/analytics';
import { Button } from '@cointracker/styleguide';
import { TextAndImage } from '@cointracker/styleguide/src/TextAndImage';
import CheckIcon from '@cointracker/styleguide/src/icons/check-quiz-flow.svg?react';
import CoinbaseIcon from '@cointracker/styleguide/src/icons/partners/Coinbase (Text).svg?react';
import HRBlockIcon from '@cointracker/styleguide/src/icons/partners/H&R Block (Text).svg?react';
import TurboTaxIcon from '@cointracker/styleguide/src/icons/partners/Intuit TurboTax (Text).svg?react';
import OpenSeaIcon from '@cointracker/styleguide/src/icons/partners/OpenSea (Text).svg?react';
import UniswapIcon from '@cointracker/styleguide/src/icons/partners/Uniswap (Text).svg?react';
import { Body2, Body4, H4 } from '@cointracker/styleguide/src/typography';
import { URLS } from '@cointracker/ui';
import classNames from 'clsx';
import { forwardRef, type Ref } from 'react';
import answerImageUrl from '../images/answer.webp?url';
import {
  button,
  content,
  list,
  listItem,
  partner,
  partnerRow,
  partners,
  subtext,
  textAndImage,
} from './FinalBlock.css';

export interface FinalBlockProps {
  className?: string;
}

export const FinalBlock = forwardRef(
  ({ className, ...rest }: FinalBlockProps, ref: Ref<HTMLDivElement>) => {
    return (
      <TextAndImage
        className={classNames(className, textAndImage)}
        ref={ref}
        desktopImageOnly
        imgSrc={answerImageUrl}
        imgAlt="answer"
        {...rest}
      >
        <div className={content}>
          <H4>Seems like CoinTracker has all of your needs covered!</H4>
          <Body2 variant="secondary" className={subtext}>
            Get your optimized tax report in minutes
          </Body2>
          <ul className={list}>
            <li className={listItem}>
              <CheckIcon /> Tax summary
            </li>
            <li className={listItem}>
              <CheckIcon /> Portfolio value
            </li>
            <li className={listItem}>
              <CheckIcon /> Self serve support
            </li>
          </ul>
          <Button
            hideInitialIcon
            className={button}
            onClick={() => {
              trackSignUpButtonClicked(
                'Start for free',
                'quiz-flow',
                'Final Block',
                'Quiz Flow',
              );
              window.location.href = URLS.AUTH_SIGNUP;
            }}
          >
            Start for free
          </Button>
          <div className={partners}>
            <Body4>The offical crypto tax partner of</Body4>
            <div className={partnerRow}>
              <CoinbaseIcon width={93} className={partner} />
              <UniswapIcon width={92} className={partner} />
              <OpenSeaIcon width={73} className={partner} />
              <TurboTaxIcon width={81} className={partner} />
              <HRBlockIcon width={100} className={partner} />
            </div>
          </div>
        </div>
      </TextAndImage>
    );
  },
);

FinalBlock.displayName = 'FinalBlock';
